import { z } from 'zod'
import { Model } from '../../_kernel/architecture'

export type PropertyHighlightedValue = boolean

export const PropertyHighlightedValidation = z.object({
  value: z.boolean().optional(),
})

export class PropertyHighlighted extends Model {
  static create({ value }: z.infer<typeof PropertyHighlightedValidation>) {
    PropertyHighlightedValidation.parse({ value })
    return new PropertyHighlighted(value)
  }

  static fromJSON(json?: ReturnType<PropertyHighlighted['toJSON']>) {
    if (typeof json !== 'boolean') {
      return PropertyHighlighted.empty()
    }
    return PropertyHighlighted.create({ value: json })
  }

  static empty() {
    return new PropertyHighlighted()
  }

  static fromHighlightedProperty(
    highlightedPropertyId: string | undefined,
    propertyId: number,
    propertyHighlighted?: boolean
  ) {
    const isHighlighted =
      (highlightedPropertyId && parseInt(highlightedPropertyId) === propertyId) ||
      propertyHighlighted

    return PropertyHighlighted.create({ value: isHighlighted })
  }

  constructor(private readonly _value?: PropertyHighlightedValue) {
    super()
  }

  value() {
    return this._value
  }

  isEmpty() {
    return this._value === undefined
  }

  toJSON() {
    return this._value
  }
}
